import { ref, watch } from 'vue';

export function useTableData(getRows, pageSize = 10) {

  if(pageSize === false) pageSize = 1000000;
  
  const data = ref([]);
  const loading = ref(false);
  const error = ref(null);
  const pagination = ref({
    page: 1,
    pageSize: pageSize,
    totalPages: 1,
  });
  const params = ref({});
  const searchQuery = ref('');

  const fetchData = async (_params) => {
    if(_params) params.value = _params;
    loading.value = true;
    getRows(pagination.value.page, searchQuery.value, params.value, pagination.value.pageSize).then(result => {
      data.value = result.data; // Assicurati che i dati siano correttamente assegnati (potrebbe essere data.items o data)
      pagination.value.totalPages = Math.ceil(result.total / result.length);
      pagination.value.pageSize = result.length;
      loading.value = false;
    }).catch(() => {
      loading.value = false; // Se c'è un errore, disattiva il caricamento
    });
  };

  const handlePageChange = (page) => {
    console.log('CALL1');
    pagination.value.page = page;
  };
  
  const handlePaginationUpdate = ({ total, page }) => {
    pagination.value.totalPages = total;
    pagination.value.page = page;
  };

  const handleSearchChange = (search) => {
    searchQuery.value = search;
    pagination.value.page = 1; // Torna alla prima pagina quando viene eseguita una nuova ricerca
  };


  watch([() => pagination.value.page, searchQuery], () => fetchData());

  return {
    data,
    loading,
    error,
    pagination,
    handlePageChange,
    handlePaginationUpdate,
    handleSearchChange,
    fetchData,
  };
}
